<template>
    <VContainer>
        <div class="text-left">
            <h2><VIcon icon="mdi-information"></VIcon> About Me</h2>
            <p class="mt-2">
                Hi there! Welcome to my site. I am a software engineer with a passion for building web applications. I have experience in a variety of programming languages and frameworks, and I am always eager to learn new technologies. In my free time, I enjoy walking, cooking, and spending time with my family and friends. Thanks for visiting!
            </p>
            <VDivider class="my-4"></VDivider>
            <h2 class="mt-2"><VIcon icon="mdi-star-outline"></VIcon> Skills</h2>
            <p class="mt-2">
                <VChip v-for="(skill, index) in skills" :key="index" class="mr-2 mb-2" color="indigo-lighten-1" label>
                     <VIcon v-if="skill.icon" :icon="skill.icon"></VIcon><span class="ml-1">{{ skill.name }}</span>
                </VChip>
            </p>
            <VDivider class="my-4"></VDivider>
            <h2 class="mt-2"><VIcon icon="mdi-folder-outline"></VIcon>Projects</h2>
            <p class="mt-2">
                I have worked on a variety of projects throughout my career, ranging from small web applications to large enterprise systems. Some of my notable projects include:
                <VList class="mt-2">
                    <VListItem>
                        <VListItemTitle>
                            <strong>AI Integration (2025 - Present):</strong>
                        </VListItemTitle>
                        Integrated an AI powered chatbot in the application that automated frequently asked questions and also answered questions regarding tickets.
                        Developed a feature that helped users find duplicate tickets using AI.
                    </VListItem>
                    <VListItem>
                        <VListItemTitle>
                            <strong>TFS Interface (2017 - Present):</strong>
                        </VListItemTitle>
                        Developed and maintained a TFS interface between the internal ticketing system and TFS instance to help R&D groups manage their tickets.
                    </VListItem>
                    <VListItem>
                        <VListItemTitle>
                            <strong>Maintained Quality Applications (2012 - 2014):</strong> 
                        </VListItemTitle>
                        Maintained a Web-based system written in VB from 2012 to 2014. Quality Applications are used by the company's Quality group to record audits and the actions based on results.
                    </VListItem>
                    <VListItem>
                        <VListItemTitle>
                            <strong>XML Interface with a client (2011):</strong> 
                        </VListItemTitle>
                        An XML interface written in Perl that allowed for communications between the customer internal ticketing system and our internal ticketing system.
                    </VListItem>
                </VList>
            </p>
        </div>
    </VContainer>
</template>

<script>
export default {
    name: "AboutOverview",
    data() {
        return {
            skills: [
                {
                    name: "Agile Development | SCRUM",
                    icon: "mdi-chart-timeline-variant-shimmer"
                },
                {
                    name: "Web Responsive Design",
                    icon: "mdi-responsive"
                },
                {
                    name: "RESTful APIs",
                    icon: "mdi-api"
                },
                {
                    name: "JavaScript",
                    icon: "mdi-language-javascript"
                },
                {
                    name: "VueJS",
                    icon: "mdi-vuejs"
                },
                {
                    name: "HTML",
                    icon: "mdi-language-html5"
                },
                {
                    name: "CSS",
                    icon: "mdi-language-css3"
                },
                {
                    name: "Java",
                    icon: "mdi-language-java"
                },
                {
                    name: "Spring Boot",
                    icon: "mdi-leaf"
                },
                {
                    name: "PHP",
                    icon: "mdi-language-php"
                },
                {
                    name: "C#",
                    icon: "mdi-language-csharp"
                },
                {
                    name: "Perl"
                },
                {
                    name: "Version Control (Mercurial, GitHub)",
                    icon: "mdi-source-branch"
                },
                {
                    name: "Relational Databases (Ingres, PostgreSQL, MySQL)",
                    icon: "mdi-database"
                },
                {
                    name: "Jira",
                    icon: "mdi-jira"
                },
                {
                    name: "Github",
                    icon: "mdi-github"
                },
                {
                    name: "Github Actions",
                    icon: "mdi-github"
                },
                {
                    name: "Continuous Integration/Continuous Deployment (CI/CD)",
                    icon: "mdi-cogs"
                },
                {
                    name: "Code Review",
                    icon: "mdi-eye-check"
                },
                {
                    name: "Github Packages",
                    icon: "mdi-github"
                },
                {
                    name: "Amazon S3",
                    icon: "mdi-aws"
                },
                {
                    name: "AWS CloudFront",
                    icon: "mdi-aws"
                },
                {
                    name: "Amazon Route53",
                    icon: "mdi-aws"
                }
            ]
        };
    },
    mounted() {
        document.title = 'PEREY | ME - About';
    },
};
</script>

<style>
</style>